"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ArrowUp } from "lucide-react";
function FooterContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const services = ["Klasická masáž", "Lingamu masáž", "Masáž se dvěma masérkami", "Erotická masáž pro páry"];
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <div className="flex flex-col w-full">
      {}
      <div className="w-full max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <span className="text-xl font-serif font-bold tracking-[0.2em] text-foreground uppercase">
                Sensu
              </span>
            </Link>
            <div className="flex flex-col gap-2 mt-4 text-sm text-muted-foreground font-default">
              <p>Teplice, Česká Republika</p>
              <p>masazesensu@seznam.cz</p>
              <p>+420 733 465 127</p>
              <div className="mt-2 inline-flex items-center px-2 py-1 border border-primary/40 rounded-sm text-[10px] font-bold text-primary uppercase tracking-widest">
                Pouze pro Osoby Starší 18 Let
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-semibold tracking-widest uppercase text-sm text-foreground">
              Navigace
            </h3>
            {loading ? <div className="flex flex-col gap-3">
                {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded" />)}
              </div> : <ul className="flex flex-col gap-3">
                {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                    <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors font-default">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>}
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-semibold tracking-widest uppercase text-sm text-foreground">
              Služby
            </h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/PricingAndServicesPage" className="text-sm text-muted-foreground hover:text-primary transition-colors font-default truncate block" title={service}>
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-semibold tracking-widest uppercase text-sm text-foreground">
              Dostupnost
            </h3>
            <div className="flex flex-col gap-3 text-sm text-muted-foreground font-default">
              <div className="flex justify-between items-center border-b border-border/30 pb-2">
                <span>REZERVACE</span>
                <span className="text-foreground">TELEFONICKY</span>
              </div>
              <div className="flex justify-between items-center border-b border-border/30 pb-2">
                <span>PLATBA</span>
                <span className="text-foreground">HOTOVĚ</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {}
      <div className="w-full bg-black border-t border-border/20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-4">
          
          {}
          <div className="flex flex-wrap items-center gap-4 text-[10px] font-default text-muted-foreground/50 uppercase tracking-widest">
            <span>
              © {new Date().getFullYear()}{" "}
              <Link to="/HomePage" className="font-serif tracking-[0.2em] hover:text-primary transition-colors">
                SENSU
              </Link>
              {" "}ART OF INTIMACY
            </span>
            <span className="hidden sm:inline text-border/30">|</span>
            <span>Všechna práva vyhrazena</span>
          </div>

          {}
          <div className="flex items-center gap-6 text-[10px] font-default tracking-widest">
            <Link to="/TermsAndConditionsPage" className="text-muted-foreground/50 hover:text-primary transition-colors uppercase">
              PODMÍNKY A SOUKROMÍ
            </Link>
            <Button variant="ghost" size="icon" onClick={scrollToTop} className="size-8 rounded-lg border border-primary/20 text-primary hover:bg-primary/10 hover:text-primary transition-all ml-2" aria-label="Back to top">
              <ArrowUp className="size-3.5" />
            </Button>
          </div>

        </div>
      </div>
    </div>;
}
export default function TerminalFooter() {
  return <section data-section-id="222491" id="footer" className="bg-background text-foreground w-full overflow-hidden border-t border-border/20">
      <MenuProvider menu_id="48">
        <FooterContent />
      </MenuProvider>
    </section>;
}